export enum CompanyStatus {
  public_company = 'Public Company',
  educational_institution = 'Educational Institution',
  nonprofit = 'Nonprofit',
  government_agency = 'Government Agency',
  partnership = 'Partnership',
  privately_held = 'Privately Held',
  self_employed = 'Self-Employed',
  sole_proprietorship = 'Sole Proprietorship',
}
export enum CompanyActiveStatus {
  active = 'Active',
  inactive = 'Inactive',
}
export enum CompanySourceName {
  cineuropa = 'Cineuropa',
  gala_global = 'Gala Global',
  kftv = 'KFTV',
  miptv_2021 = 'MIPTV 2021',
  omdb = 'OMDB',
  production_hub = 'Production Hub',
  vitrina = 'Vitrina',
  wikidata = 'Wikidata',
}

export enum CompanySize {
  '0_1_employees' = '0-1 employees',
  '2_10_employees' = '2-10 employees',
  '11_50_employees' = '11-50 employees',
  '51_200_employees' = '51-200 employees',
  '201_500_employees' = '201-500 employees',
  '501_1000_employees' = '501-1,000 employees',
  '1001_5000_employees' = '1001-5000 employees',
  '5001_10000_employees' = '5,001-10,000 employees',
  '10001_employees' = '10,001+ employees',
}

export enum PublishStatus {
  'PS_-1' = 'Manually Unpublished',
  'PS_0' = 'Auto Unpublished',
  'PS_1' = 'Auto Published',
  'PS_2' = 'Manually Published',
  'PS_-2' = 'Parked',
}

export enum ServicePublishStatus {
  'PS_0' = 'Unpublished',
  'PS_1' = 'Published',
}


export enum PublishStatusEnumNumeric {
  'Manually Unpublished' = -1,
  'Unpublished' = 0,
  'Published' = 1,
  'Manually Published' = 2,
  'Parked' = -2,
}

export enum ServicePublishStatusEnumNumeric {
  'Unpublished' = 0,
  'Published' = 1,
}

export enum CompanyTypesEnumNumeric {
  'Financing' = 1,
  'Legal' = 2,
  'Talent Management' = 3,
  'Pre-Production' = 4,
  'Production House' = 5,
  'Production Services' = 6,
  'Sales Agent' = 11,
  'Distribution Company' = 12,
  'Packaging & Delivery' = 13,
  'Theatre Chain' = 14,
  'OTT Provider' = 15,
  'Broadcaster' = 16,
  'Operator' = 17,
  'Others' = 18,
  'Post-Production' = 7,
  'Marketing & Promotions' = 9,
  'Associations' = 10,
  'Localisation' = 8,
  '3D Camera' = 101,
  'Subtitling, Titles & Closed Captions' = 19,
  'Craft Services' = 20,
  'Video Stock Footage' = 21,
  'Color Processing' = 22,
  'Video Camera Equipment' = 23,
  '5.1 Stereo Surround' = 24,
  'Pre Production Services' = 25,
  'Stills Photographers' = 26,
  'Animal Wranglers' = 27,
  'Remote Heads' = 28,
  'Sound Recording' = 29,
  'Video Assist Equipment' = 30,
  'Stills Photography Production Services' = 31,
  'Authors' = 32,
  'Web Design' = 33,
  'Digital Intermediate Services' = 34,
  'Production Insurance' = 35,
  'Transportation Services' = 36,
  'Prop Vehicles' = 37,
  'Editing Services' = 38,
  'Animal Action Monitoring' = 39,
  'Color Correction / Color Grading' = 40,
  'Archival Footage' = 41,
  'Studios / Soundstages' = 42,
  'Art Department Services' = 43,
  'Funding' = 44,
  'Dailies' = 45,
  'Audio Post Production' = 46,
  'Stabilized Remote Camera Systems' = 47,
  'Technical Support' = 48,
  'Creative Consultancy Services' = 49,
  'Storyboards' = 50,
  'Permit Services' = 51,
  'Walla Group' = 52,
  'Compositing' = 53,
  'Voice Casting' = 54,
  'Online Editing' = 55,
  'Approval and Certification Services' = 56,
  'Blu-Ray / DVD / USB Services - Duplication, Replication, Authoring' = 57,
  'Animals Trainers' = 58,
  'Catering Services' = 59,
  'Marketing , Promotion & Advertising Services' = 60,
  'Stabilized Camera Systems' = 61,
  'Cutting Room' = 62,
  'Stills Photography' = 63,
  'Digital Mastering' = 64,
  'Post Production Services' = 65,
  'Underwater Camera Equipment' = 66,
  'Post Production, Animation' = 67,
  'Grip & Lighting Equipment' = 68,
  'Matte Painting' = 69,
  'Telecine Transfers' = 70,
  'Casting Services' = 71,
  'Dubbing Services' = 72,
  'ADR / Automated Dialogue Replacement' = 73,
  'Lighting Equipment' = 74,
  'Production Facilities' = 75,
  'Corporate Credit Services' = 76,
  'Underwater Photography Equipment' = 77,
  'Extras Casting Services' = 78,
  'Cloud Computing & Rendering Services' = 79,
  'Camera Equipment & Lenses' = 80,
  'Credits, Titles & Graphics' = 81,
  'Dollies' = 82,
  'Health & Safety' = 83,
  'Production' = 84,
  'Grip Equipment' = 85,
  'Digital Services' = 86,
  'Camera & Lighting Equipment' = 87,
  'Visual Effects' = 88,
  'Editing Equipment' = 89,
  'Security Services' = 90,
  'Production Equipment & Services' = 91,
  'Transcription Services' = 92,
  'Film / Video Transfers' = 93,
  'Wireless Camera System' = 95,
  'Still Images' = 96,
  'Negative Services' = 97,
  'Sound Effects' = 98,
  'Travel Agents' = 99,
  'Public Relations / Unit Publicists' = 100,
  'Promos & Trailers' = 102,
  'Location Services & Facilities' = 103,
  'Banking Services' = 104,
  'Legal Services' = 105,
  'Office & Payroll Services' = 106,
  'Post Production Facilities' = 107,
  'Underwater Filming Production Equipment' = 108,
  'Stills Photography Equipment' = 109,
  'Digital Post Production' = 110,
  'Animation Production Companies' = 111,
  'Audio Mixing' = 112,
  'Animal Services' = 113,
  'Recording Studios' = 114,
  'Editing Facilities' = 115,
  'Sound Services' = 116,
  'Technical Advisors' = 117,
  'Electric Equipment' = 118,
  'Remote Camera Systems' = 119,
  'HD / UHD / 4K Post Production Editing Services' = 120,
  'VTR Decks / Players / Recorders' = 121,
  'Sound Mixing' = 122,
  'Digital Compositing' = 123,
  'Cranes & Dollies' = 124,
  'Aerial Filming' = 125,
  'Translation Services' = 126,
  'Accommodation Services' = 127,
  'Cherry Picker Rental' = 128,
  'Film / 16mm / 35mm Camera' = 129,
  'Auditing' = 130,
  'Prop Vehicle Rental' = 131,
  'Stills Footage' = 132,
  'Grip & Electrical Equipment' = 133,
  'Branding Activities' = 134,
  'Hair & Make-Up Services' = 135,
  'Research Services' = 136,
  'Sound Design' = 137,
  'Product Placement' = 138,
  'Foley Stages' = 139,
  'Sound Editing' = 140,
  'Filming Cars & Tracking Vehicles' = 141,
  'Sound Equipment' = 142,
  'Costume & Wardrobe' = 143,
  'Finance & Insurance' = 144,
  'Management & Consultancy' = 145,
  '3D Content Creation' = 146,
  'Camera & Grip Equipment Rental' = 147,
  'Color & Prints' = 148,
  'Audio Visual Services' = 149,
  'Soundtrack Production / Jingles Production' = 150,
  'Aerial Coordinators' = 151,
  'Stock Footage' = 152,
  '2D & 3D Animation' = 153,
  'Aerial Camera Mount Rental' = 154,
  'Video Post Production' = 155,
  'Digital Media Services' = 156,
  '2K/4K Resolution FIlming' = 157,
  'Audio / Sound Transfers' = 158,
  'Cameras & Camera Equipment Rental' = 159,
  'Digital Asset Management (DAM) Services' = 160,
  'Digital Effects' = 161,
  'Aerial Camera Systems' = 162,
  'Action Vehicles' = 163,
  'Camera & Grip Equipment' = 164,
  'Accountancy Services' = 165,
  'Talent Agencies' = 166,
  'Stunt Services' = 167,
  'Hospitality & Logistics' = 168,
  'Video & Recording Equipment' = 169,
  'Processing Laboratories' = 170,
  'Book Publisher' = 171,
  '24 Frame Video Playback' = 172,
  'Audio Visual (AV) Equipment' = 173,
  'Crowd Casting' = 174,
  'Quality Assurance Services' = 175,
  'Special Effects' = 176,
  'Audio - Voiceover / Narration' = 177,
  'Music Recording' = 178,
  'Aerial Photography' = 179,
  'Camera Cars, Cranes & Dollies' = 180,
  'Sound Studio' = 181,
  'Animation/Computer Graphics (CGI)' = 182,
  'Military, Firearms, Weapons Props' = 183,
  'Mixing Recording Studio' = 184,
  'Music Scoring / Film Score' = 185,
  'Dialogue Editing' = 186,
  'Traffic Management Services' = 187,
  'Scriptwriting Services' = 188,
  'Underwater Camera Operators' = 189,
  'Digital Marketing' = 190,
  'Vintage Camera Rental' = 191,
  'Set Design & Construction' = 192,
  'Archive & Restoration Services' = 193,
  'Aerial Cinematography' = 194,
  'DI (Digital Intermediate)' = 195,
  'Colorists / Colour Graders' = 196,
}

export enum CompanySubTypesEnumNumeric {
  'Film Funds' = 1,
  'Talent Agency' = 2,
  'Casting' = 3,
  'Art Department Services' = 4,
  'Costume & Wardrobe Services' = 5,
  'Audio, Film & Video Stock Provider' = 6,
  'Grip Equipment Services' = 7,
  'Lighting Equipment Services' = 8,
  'Location Facilities & Services' = 9,
  'Office Services' = 10,
  'Production Equipment & Services' = 11,
  'Sound Equipment Services' = 12,
  'Camera Equipment Services' = 13,
  'Security Services' = 14,
  'Accommodation & Transport Services' = 15,
  'Special Effects' = 16,
  'Sound Stage Provider' = 17,
  'Creative Post-Production' = 18,
  'Visual Effects' = 19,
  'Post-Production Facilities' = 20,
  'Dubbing' = 21,
  'Subtitling' = 22,
  'Voice Over' = 23,
  'Language Services Provider (LSP)' = 24,
  'Publicist' = 25,
  'Advertising & Media' = 26,
  'Film Commission' = 27,
  'Govt & Industry Body' = 28,
  'Unions & Guilds' = 29,
  'International Sales Agent' = 30,
  'Financing & Investment Services' = 31,
  'Management Services' = 32,
  'Law Firm' = 33,
}

export enum Countries {
  'Andorra' = 'Andorra',
  'United Arab Emirates' = 'United Arab Emirates',
  'Afghanistan' = 'Afghanistan',
  'Antigua and Barbuda' = 'Antigua and Barbuda',
  'Anguilla' = 'Anguilla',
  'Albania' = 'Albania',
  'Armenia' = 'Armenia',
  'Netherlands Antilles' = 'Netherlands Antilles',
  'Angola' = 'Angola',
  'Antarctica' = 'Antarctica',
  'Argentina' = 'Argentina',
  'American Samoa' = 'American Samoa',
  'Austria' = 'Austria',
  'Australia' = 'Australia',
  'Aruba' = 'Aruba',
  'Azerbaijan' = 'Azerbaijan',
  'Bosnia and Herzegovina' = 'Bosnia and Herzegovina',
  'Barbados' = 'Barbados',
  'Bangladesh' = 'Bangladesh',
  'Belgium' = 'Belgium',
  'Burkina Faso' = 'Burkina Faso',
  'Bulgaria' = 'Bulgaria',
  'Bahrain' = 'Bahrain',
  'Burundi' = 'Burundi',
  'Benin' = 'Benin',
  'Bermuda' = 'Bermuda',
  'Brunei Darussalam' = 'Brunei Darussalam',
  'Bolivia' = 'Bolivia',
  'Brazil' = 'Brazil',
  'Bahamas' = 'Bahamas',
  'Bhutan' = 'Bhutan',
  'Bouvet Island' = 'Bouvet Island',
  'Botswana' = 'Botswana',
  'Belize' = 'Belize',
  'Belarus' = 'Belarus',
  'Canada' = 'Canada',
  'Cocos  Islands' = 'Cocos  Islands',
  'Central African Republic' = 'Central African Republic',
  'Congo' = 'Congo',
  'Switzerland' = 'Switzerland',
  "Cote D'Ivoire" = "Cote D'Ivoire",
  'Cook Islands' = 'Cook Islands',
  'Chile' = 'Chile',
  'Cameroon' = 'Cameroon',
  'China' = 'China',
  'Colombia' = 'Colombia',
  'Costa Rica' = 'Costa Rica',
  'Serbia and Montenegro' = 'Serbia and Montenegro',
  'Cuba' = 'Cuba',
  'Cape Verde' = 'Cape Verde',
  'Christmas Island' = 'Christmas Island',
  'Cyprus' = 'Cyprus',
  'Czech Republic' = 'Czech Republic',
  'Germany' = 'Germany',
  'Djibouti' = 'Djibouti',
  'Denmark' = 'Denmark',
  'Dominica' = 'Dominica',
  'Dominican Republic' = 'Dominican Republic',
  'Algeria' = 'Algeria',
  'Ecuador' = 'Ecuador',
  'Estonia' = 'Estonia',
  'Egypt' = 'Egypt',
  'Western Sahara' = 'Western Sahara',
  'Eritrea' = 'Eritrea',
  'Spain' = 'Spain',
  'Ethiopia' = 'Ethiopia',
  'Finland' = 'Finland',
  'Fiji' = 'Fiji',
  'Falkland Islands' = 'Falkland Islands',
  'Serbia' = 'Serbia',
  'Micronesia' = 'Micronesia',
  'Faeroe Islands' = 'Faeroe Islands',
  'France' = 'France',
  'Gabon' = 'Gabon',
  'United Kingdom' = 'United Kingdom',
  'Grenada' = 'Grenada',
  'Georgia' = 'Georgia',
  'French Guiana' = 'French Guiana',
  'Ghana' = 'Ghana',
  'Gibraltar' = 'Gibraltar',
  'Greenland' = 'Greenland',
  'Gambia' = 'Gambia',
  'Guinea' = 'Guinea',
  'Guadaloupe' = 'Guadaloupe',
  'Equatorial Guinea' = 'Equatorial Guinea',
  'Greece' = 'Greece',
  'South Georgia and the South Sandwich Islands' = 'South Georgia and the South Sandwich Islands',
  'Guatemala' = 'Guatemala',
  'Guam' = 'Guam',
  'Guinea-Bissau' = 'Guinea-Bissau',
  'Guyana' = 'Guyana',
  'Hong Kong' = 'Hong Kong',
  'Heard and McDonald Islands' = 'Heard and McDonald Islands',
  'Honduras' = 'Honduras',
  'Croatia' = 'Croatia',
  'Haiti' = 'Haiti',
  'Hungary' = 'Hungary',
  'Indonesia' = 'Indonesia',
  'Ireland' = 'Ireland',
  'Israel' = 'Israel',
  'India' = 'India',
  'British Indian Ocean Territory' = 'British Indian Ocean Territory',
  'Iraq' = 'Iraq',
  'Iran' = 'Iran',
  'Iceland' = 'Iceland',
  'Italy' = 'Italy',
  'Jamaica' = 'Jamaica',
  'Jordan' = 'Jordan',
  'Japan' = 'Japan',
  'Kenya' = 'Kenya',
  'Kyrgyz Republic' = 'Kyrgyz Republic',
  'Cambodia' = 'Cambodia',
  'Kiribati' = 'Kiribati',
  'Comoros' = 'Comoros',
  'St. Kitts and Nevis' = 'St. Kitts and Nevis',
  'North Korea' = 'North Korea',
  'Kuwait' = 'Kuwait',
  'Cayman Islands' = 'Cayman Islands',
  'Kazakhstan' = 'Kazakhstan',
  "Lao People's Democratic Republic" = "Lao People's Democratic Republic",
  'Lebanon' = 'Lebanon',
  'St. Lucia' = 'St. Lucia',
  'Liechtenstein' = 'Liechtenstein',
  'Sri Lanka' = 'Sri Lanka',
  'Liberia' = 'Liberia',
  'Lesotho' = 'Lesotho',
  'Lithuania' = 'Lithuania',
  'Luxembourg' = 'Luxembourg',
  'Latvia' = 'Latvia',
  'Libyan Arab Jamahiriya' = 'Libyan Arab Jamahiriya',
  'Morocco' = 'Morocco',
  'Monaco' = 'Monaco',
  'Moldova' = 'Moldova',
  'Madagascar' = 'Madagascar',
  'Marshall Islands' = 'Marshall Islands',
  'Macedonia' = 'Macedonia',
  'Mali' = 'Mali',
  'Myanmar' = 'Myanmar',
  'Mongolia' = 'Mongolia',
  'Macao' = 'Macao',
  'Northern Mariana Islands' = 'Northern Mariana Islands',
  'Martinique' = 'Martinique',
  'Mauritania' = 'Mauritania',
  'Montserrat' = 'Montserrat',
  'Malta' = 'Malta',
  'Mauritius' = 'Mauritius',
  'Maldives' = 'Maldives',
  'Malawi' = 'Malawi',
  'Mexico' = 'Mexico',
  'Malaysia' = 'Malaysia',
  'Mozambique' = 'Mozambique',
  'Namibia' = 'Namibia',
  'New Caledonia' = 'New Caledonia',
  'Niger' = 'Niger',
  'Norfolk Island' = 'Norfolk Island',
  'Nigeria' = 'Nigeria',
  'Montenegro' = 'Montenegro',
  'Nicaragua' = 'Nicaragua',
  'Netherlands' = 'Netherlands',
  'Norway' = 'Norway',
  'Nepal' = 'Nepal',
  'Nauru' = 'Nauru',
  'Niue' = 'Niue',
  'New Zealand' = 'New Zealand',
  'Oman' = 'Oman',
  'Panama' = 'Panama',
  'Peru' = 'Peru',
  'French Polynesia' = 'French Polynesia',
  'Papua New Guinea' = 'Papua New Guinea',
  'Philippines' = 'Philippines',
  'Yugoslavia' = 'Yugoslavia',
  'Kosovo' = 'Kosovo',
  'Czechoslovakia' = 'Czechoslovakia',
  'Pakistan' = 'Pakistan',
  'Poland' = 'Poland',
  'St. Pierre and Miquelon' = 'St. Pierre and Miquelon',
  'Pitcairn Island' = 'Pitcairn Island',
  'Puerto Rico' = 'Puerto Rico',
  'Palestinian Territory' = 'Palestinian Territory',
  'Portugal' = 'Portugal',
  'Palau' = 'Palau',
  'Paraguay' = 'Paraguay',
  'Qatar' = 'Qatar',
  'Reunion' = 'Reunion',
  'Romania' = 'Romania',
  'Russia' = 'Russia',
  'Rwanda' = 'Rwanda',
  'Saudi Arabia' = 'Saudi Arabia',
  'Solomon Islands' = 'Solomon Islands',
  'Seychelles' = 'Seychelles',
  'Sudan' = 'Sudan',
  'Sweden' = 'Sweden',
  'Singapore' = 'Singapore',
  'St. Helena' = 'St. Helena',
  'Slovenia' = 'Slovenia',
  'Svalbard & Jan Mayen Islands' = 'Svalbard & Jan Mayen Islands',
  'Slovakia' = 'Slovakia',
  'Sierra Leone' = 'Sierra Leone',
  'San Marino' = 'San Marino',
  'Senegal' = 'Senegal',
  'Somalia' = 'Somalia',
  'Suriname' = 'Suriname',
  'Sao Tome and Principe' = 'Sao Tome and Principe',
  'El Salvador' = 'El Salvador',
  'Syrian Arab Republic' = 'Syrian Arab Republic',
  'Swaziland' = 'Swaziland',
  'Turks and Caicos Islands' = 'Turks and Caicos Islands',
  'Chad' = 'Chad',
  'French Southern Territories' = 'French Southern Territories',
  'Togo' = 'Togo',
  'Thailand' = 'Thailand',
  'Tajikistan' = 'Tajikistan',
  'Tokelau' = 'Tokelau',
  'Timor-Leste' = 'Timor-Leste',
  'Turkmenistan' = 'Turkmenistan',
  'Tunisia' = 'Tunisia',
  'Tonga' = 'Tonga',
  'Turkey' = 'Turkey',
  'Trinidad and Tobago' = 'Trinidad and Tobago',
  'Tuvalu' = 'Tuvalu',
  'Taiwan' = 'Taiwan',
  'Tanzania' = 'Tanzania',
  'Ukraine' = 'Ukraine',
  'Uganda' = 'Uganda',
  'United States Minor Outlying Islands' = 'United States Minor Outlying Islands',
  'United States of America' = 'United States of America',
  'Uruguay' = 'Uruguay',
  'Uzbekistan' = 'Uzbekistan',
  'Holy See' = 'Holy See',
  'St. Vincent and the Grenadines' = 'St. Vincent and the Grenadines',
  'Venezuela' = 'Venezuela',
  'British Virgin Islands' = 'British Virgin Islands',
  'US Virgin Islands' = 'US Virgin Islands',
  'Vietnam' = 'Vietnam',
  'Vanuatu' = 'Vanuatu',
  'Wallis and Futuna Islands' = 'Wallis and Futuna Islands',
  'Samoa' = 'Samoa',
  'Yemen' = 'Yemen',
  'Mayotte' = 'Mayotte',
  'South Africa' = 'South Africa',
  'Zambia' = 'Zambia',
  'Zimbabwe' = 'Zimbabwe',
  'South Korea' = 'South Korea',
  'East Germany' = 'East Germany',
  'Soviet Union' = 'Soviet Union',
  'South Sudan' = 'South Sudan',
}

// 'TMDB' = 1001,
// 'OMDB' = 2001,
// 'KFTV' = 3001,
export enum CompanyDataSource {
  'OMDB' = 'OMDB',
  'KFTV' = 'KFTV',
  'Vitrina' = 'Vitrina',
  'Wikidata' = 'Wikidata',
  'Cineuropa' = 'Cineuropa',
  'MIPTV 2021' = 'MIPTV 2021',
  'Gala Global' = 'Gala Global',
  'Production Hub' = 'Production Hub',
  'Unifrance' = 'Unifrance',
  'Location Guide' = 'Location Guide',
  'FilmItalia' = 'FilmItalia',
  'FilmArt 2020' = 'FilmArt 2020',
  'NATPE 2020' = 'NATPE 2020',
  'BBC Supplier' = 'BBC Supplier',
  'GVD' = 'GVD',
}

export enum ActionType {
  'Added' = 'Added',
  'Modified' = 'Modified',
  'Deleted' = 'Deleted'
}

export enum FieldNames {
  "# of Badges" = "# of Badges",
  "# of Company-Content Relations" = "# of Company-Content Relations",
  "# of C2P Relations - DELI" = "# of C2P Relations - DELI",
  "# of Badge Relations - Deal" = "# of Badge Relations - Deal",
  "# of Services Attributes - Company" = "# of Services Attributes - Company",
  "# of C2P Relations" = "# of C2P Relations",
  "# of C2C Relations" = "# of C2C Relations",
  "# of C2P Relations - Self Service" = "# of C2P Relations - Self Service",
  "# of Media" = "# of Media",
  "# of Person - TMDB" = "# of Person - TMDB",
  "# of Companies" = "# of Companies",
  "# of Content - DELI" = "# of Content - DELI",
  "# of Person - DELI" = "# of Person - DELI",
  "# of Badge Relations - Content" = "# of Badge Relations - Content",
  "# of Badge Relations - Company" = "# of Badge Relations - Company",
  "# of Content" = "# of Content",
  "# of Services" = "# of Services",
  "# of Services Attributes - Content" = "# of Services Attributes - Content",
  "# of Content - TMDB" = "# of Content - TMDB",
  "# of Person - Self Service" = "# of Person - Self Service",
  "# of Person" = "# of Person",
  "# of Deals" = "# of Deals"
}

export enum GroupCompanyMaster {
  'ABC' = 'ABC',
  'Al Jazeera' = 'Al Jazeera',
  'All3 Media' = 'All3 Media',
  'Altitude Film Entertainment' = 'Altitude Film Entertainment',
  'Amazon' = 'Amazon',
  'AMC Networks' = 'AMC Networks',
  'Apple' = 'Apple',
  'Arab Media Network' = 'Arab Media Network',
  'ARD' = 'ARD',
  'Australian Broadcasting Company (ABC)' = 'Australian Broadcasting Company (ABC)',
  'Balaji Telefilms' = 'Balaji Telefilms',
  'Bang Zoom!' = 'Bang Zoom!',
  'Banijay' = 'Banijay',
  'BBC' = 'BBC',
  'Blue Ant' = 'Blue Ant',
  'Blumhouse Productions' = 'Blumhouse Productions',
  'BTI Studios' = 'BTI Studios',
  'Canal+ Group' = 'Canal+ Group',
  'CBC' = 'CBC',
  'Cineflix' = 'Cineflix',
  'Comcast' = 'Comcast',
  'Deluxe' = 'Deluxe',
  'Discovery' = 'Discovery',
  'Entertainment One' = 'Entertainment One',
  'ErosSTX' = 'ErosSTX',
  'Fox' = 'Fox',
  'Framestore' = 'Framestore',
  'ITV' = 'ITV',
  'Iyuno' = 'Iyuno',
  'Lionsgate' = 'Lionsgate',
  'MGM' = 'MGM',
  'NBCUniversal' = 'NBCUniversal',
  'NENT' = 'NENT',
  'Netflix' = 'Netflix',
  'Prime Focus' = 'Prime Focus',
  'ProSiebenSat.1 Media' = 'ProSiebenSat.1 Media',
  'Red Arrow Studios' = 'Red Arrow Studios',
  'Roku' = 'Roku',
  'RTL Group' = 'RTL Group',
  'Showtime' = 'Showtime',
  'Sky Group' = 'Sky Group',
  'Sony Pictures' = 'Sony Pictures',
  'SVT' = 'SVT',
  'Tanweer Group' = 'Tanweer Group',
  'The Walt Disney Company' = 'The Walt Disney Company',
  'Turner' = 'Turner',
  'ViacomCBS' = 'ViacomCBS',
  'Viasat' = 'Viasat',
  'VSI' = 'VSI',
  'WarnerMedia Studios & Networks' = 'WarnerMedia Studios & Networks',
  'Wild Bunch' = 'Wild Bunch',
  'Yash Raj Films' = 'Yash Raj Films',
  'YLE' = 'YLE',
  'YouTube' = 'YouTube',
  'ZDF' = 'ZDF',
  'Zee' = 'Zee',
  'Technicolor' = 'Technicolor',
}
